import React from 'react'
import moment from 'moment'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'
import AppImageDetail from '../general-details/AppImageDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'

const AppDetails = ({
  timeOffRequestDetails,
  handleViewFile
}) => {
  return (
    <>
      {
        (timeOffRequestDetails?.leave_type?.code === 'SICK' || timeOffRequestDetails?.leave_type?.code === 'BEREAVEMENT') && (
          <CRow className='mb-4'>
            <AppTextColumnDetails
              colSize="4"
              title={`Approved Days for ${timeOffRequestDetails?.leave_type?.code === 'SICK' ? 'Sick Leave' : 'Bereavement Leave'}`}
              subtitle={timeOffRequestDetails?.approval_days ?
                <div className="d-flex flex-column align-items-start">
                  <span className="text-body">{timeOffRequestDetails?.approval_days} Days</span>
                  {
                    Number(timeOffRequestDetails?.days_count - timeOffRequestDetails?.approval_days) > 0 && (
                      <span className="text-body" style={{ fontSize: "12px" }}>{`(${Number(timeOffRequestDetails?.days_count - timeOffRequestDetails?.approval_days)} days will be deducted from employee's annual balance)` }</span>
                    )
                  }
                </div> :
                <span className="text-body">-</span>
              }
              className="ms-2 py-2 bg-warning border rounded"
            />
          </CRow>
        )
      }
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Employee ID"
          subtitle={timeOffRequestDetails?.employee ? timeOffRequestDetails?.employee?.id : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Employee Name"
          subtitle={timeOffRequestDetails?.employee ? `${timeOffRequestDetails?.employee?.first_name} ${timeOffRequestDetails?.employee?.last_name}` : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Employee Position"
          subtitle={timeOffRequestDetails?.employee ? timeOffRequestDetails?.employee?.job_title : "-"}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Time-Off Request ID"
          subtitle={timeOffRequestDetails?.reference ? `${timeOffRequestDetails?.reference}` : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Time-Off Request Type"
          subtitle={timeOffRequestDetails?.leave_type ? `${timeOffRequestDetails?.leave_type?.name}` : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Time-Off Request Status"
          subtitle={timeOffRequestDetails?.status ? `${timeOffRequestDetails?.status?.replace(/_/g, ' ')?.toUpperCase()}` : "-"}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Time-Off Duration"
          subtitle={timeOffRequestDetails?.days_count ? `${timeOffRequestDetails?.days_count} Business Days ${timeOffRequestDetails?.leave_type?.code === "EMERGENCY" ? timeOffRequestDetails?.is_emergency_over_4_hours ? "(>4 hours)" : "(<4 hours)" : ""}` : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Time-Off Request Date"
          subtitle={timeOffRequestDetails?.selected_date && timeOffRequestDetails?.selected_date.length > 0 ? timeOffRequestDetails?.selected_date.map((date, index) => (
            <span key={index}>
              {moment(date).format('DD MMMM YYYY')}
              {index !== timeOffRequestDetails?.selected_date.length - 1 && ', '}
            </span>
          )) : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Submission Date"
          subtitle={timeOffRequestDetails?.createdAt ? moment(timeOffRequestDetails?.createdAt).format('DD MMMM YYYY') : "-"}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Withdrawal Date"
          subtitle={timeOffRequestDetails?.withdrawn_at ? moment(timeOffRequestDetails?.withdrawn_at).format('YYYY-MM-DD') : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Cancellation Date"
          subtitle={timeOffRequestDetails?.cancellation_requested_at ? moment(timeOffRequestDetails?.cancellation_requested_at).format('YYYY-MM-DD') : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Reason For Cancellation"
          subtitle={timeOffRequestDetails?.cancellation_request_reason ? `${timeOffRequestDetails?.cancellation_request_reason}` : "-"}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Approval Notes"
          subtitle={timeOffRequestDetails?.approve_notes ? `${timeOffRequestDetails?.approve_notes}` : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Reason For Decline Approval"
          subtitle={timeOffRequestDetails?.decline_reason ? `${timeOffRequestDetails?.decline_reason}` : "-"}
        />
        <AppTextColumnDetails
          colSize="4"
          title="Reason For Decline Cancellation"
          subtitle={timeOffRequestDetails?.cancellation_rejection_reason ? `${timeOffRequestDetails?.cancellation_rejection_reason}` : "-"}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Time-Off Request Notes"
          subtitle={timeOffRequestDetails?.notes ? `${timeOffRequestDetails?.notes}` : "-"}
          />
          {
            timeOffRequestDetails?.leave_type?.code === 'UNPAID' && (
              <AppTextColumnDetails
                colSize="4"
                title="Unpaid Category"
                subtitle={timeOffRequestDetails?.unpaid_category ? `${timeOffRequestDetails?.unpaid_category == 'LOP' ? 'Loss of Pay' : 'Leave Without Pay'} (${timeOffRequestDetails?.unpaid_category})` : "-"}
              />
            )
          }
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="4"
          title="Supporting Document"
          subtitle={
            timeOffRequestDetails?.supporting_document_url ? (
              <FormFileThumbnail 
                name='file_document_submission'
                colSize='12'
                files={timeOffRequestDetails?.supporting_document_url ? [{
                  file_url: timeOffRequestDetails?.supporting_document_url,
                  file_original_name: timeOffRequestDetails?.supporting_document_original_name
                }] : []}
                className='justify-content-start align-items-center mb-3'
                handleViewFile={handleViewFile}
                disabled={true}
                isDetailPage={true}
              />
            ) : (
              "-"
            )
          }
        />
        
        <AppImageDetail
          colSize="4"
          title="Employee Signature"
          images={timeOffRequestDetails?.signature_url ? timeOffRequestDetails?.signature_url : null}
          handleViewFile={handleViewFile}
        />
      </CRow>
    </>
  )
}

export default AppDetails
